import React from "react";
import { Wind, Layers, Target, MapPin, Mountain } from "lucide-react";

/**
 * "Emerging Development Pattern" — policy-grade 2-column card layout
 * highlighting the 5 design principles the 22 workshops converge on.
 */
const ITEMS = [
  {
    n: "01",
    icon: Wind,
    label: "Small number of turbines",
    detail: "typically 1–6 per workshop proposal",
  },
  {
    n: "02",
    icon: Target,
    label: "Fewer, larger turbines",
    detail: "preferred over many smaller turbines",
  },
  {
    n: "03",
    icon: Layers,
    label: "Clustering in defined locations",
    detail: "grouped rather than dispersed across parishes",
  },
  {
    n: "04",
    icon: MapPin,
    label: "Siting aligned with infrastructure",
    detail: "roads, rail, pylons, industrial zones",
  },
  {
    n: "05",
    icon: Mountain,
    label: "Avoidance of prominent viewpoints",
    detail: "away from highly-valued landscape features",
  },
];

export default function EmergingPatternPanel() {
  return (
    <section data-testid="emerging-pattern-panel">
      <div className="mb-4">
        <h2 className="text-xl font-semibold tracking-tight text-gray-900">
          Emerging development pattern
        </h2>
        <p className="text-sm text-gray-600 mt-1 max-w-3xl">
          Across the 22 workshops, communities consistently converge on the
          following design principles — not by instruction, but through the
          configurations they proposed.
        </p>
      </div>
      <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {ITEMS.map(({ n, icon: Icon, label, detail }) => (
          <li
            key={n}
            className="group bg-white border border-gray-200 p-5 flex items-start gap-5 hover:border-[#2F4F4F] transition-colors"
            data-testid={`emerging-pattern-${n}`}
          >
            <div
              className="h-14 w-14 border border-[#2F4F4F] bg-[#F8FAF9] text-[#2F4F4F] flex items-center justify-center flex-shrink-0 group-hover:bg-[#2F4F4F] group-hover:text-white transition-colors"
              aria-hidden
            >
              <Icon className="h-7 w-7" strokeWidth={1.5} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 text-[11px] font-mono text-gray-400">
                <span>{n}</span>
                <span className="h-px flex-1 bg-gray-200" />
              </div>
              <p className="text-base font-semibold text-gray-900 mt-1 leading-snug">
                {label}
              </p>
              <p className="text-sm text-gray-600 mt-1 leading-snug">
                {detail}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
